import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVouchermag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#FFF",
		fillRule: "nonzero",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8.5 11.5a.834.834 0 0 1-.833-.834.833.833 0 1 0-1.667 0c0 1.085.698 2.002 1.667 2.347v.154a.833.833 0 1 0 1.666 0v-.154A2.497 2.497 0 0 0 11 10.666c0-1.378-1.122-2.5-2.5-2.5a.834.834 0 1 1 .833-.833.833.833 0 1 0 1.667 0c0-1.085-.7-2.002-1.667-2.347v-.153a.833.833 0 1 0-1.666 0v.154A2.496 2.496 0 0 0 6 7.334c0 1.378 1.122 2.5 2.5 2.5a.834.834 0 0 1 0 1.666z" }), /* @__PURE__ */ _jsx("path", { d: "M15.668 18.905a.79.79 0 0 1-.72.112l-4.43-1.499-2.074 1.404a.79.79 0 0 1-.887 0l-2.075-1.404-4.43 1.499a.789.789 0 0 1-.72-.112.816.816 0 0 1-.332-.66V.813C0 .364.358 0 .8 0h14.4c.442 0 .8.364.8.812v17.434c0 .26-.123.506-.332.659zm-.769-17.846H1v16.836l4.07-1.378a.856.856 0 0 1 .756.103L7.95 18.06l2.124-1.439a.865.865 0 0 1 .756-.103l4.07 1.378V1.06z" })]
	})
});
export default SvgVouchermag;
